import React from 'react';
import { AuditsTable } from '../../Agreement/Table/AgreementAuditsTable';

export default function MatrixAuditsTable() {
    return <AuditsTable statusChoiceList="masterTermVersionStatus" />;
}